/** Structured scoring catalogue + legacy chapter filter for navigation. */
import { spiritIslandChapters } from './content';
export {
  spiritIslandScoringRecords,
  filterSpiritIslandScoring,
  validateSpiritIslandScoringTables,
} from './scoringTables';
export type {
  SpiritIslandScoringRecord,
  SpiritIslandScoringModuleId,
} from './scoringTables';

/**
 * Chapters whose titles mention victory / defeat / fear / blight —
 * for chapter-based navigation (Spirit Island has no VP track).
 */
export const spiritIslandScoring = spiritIslandChapters.filter((chapter) =>
  /zwycię|porażk|strach|zaraza|koniec rundy/i.test(chapter.title)
);
